import Vue from 'vue'
import * as Sentry from '@sentry/vue';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://cedb964c6d6588224430c04706653508@o4510997598568448.ingest.de.sentry.io/4511139200106576',
  });
  Vue.prototype.$sentry = Sentry;
}
